// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2AjjL","disabled":"FileBtn_disabled__15pPE","warn":"FileBtn_warn__3mxl7","fade":"FileBtn_fade__1fYne"};